import { STTextStrikeType } from '@tencent/slide-sdk-model';

// 删除线 - sdk对上层类型映射
export const TEXT_STRIKE_TYPE_MAP = new Map([
    [STTextStrikeType?.noStrike, 'none'],
    [STTextStrikeType?.sngStrike, 'sng'],
    [STTextStrikeType?.dblStrike, 'dbl'],
]);
